// extracted by mini-css-extract-plugin
export default {"tags":"src-pages-SalesChannelProductsConfig-SalesChannelProductContent-ReviewKeywords-css-module__tags---s31R"};